import React, {createContext, useReducer, children} from 'react';
import { useImmerReducer } from 'use-immer';

import authInitialState from './state/authInitialState';
import authReducer from './reducers/authReducer';

import globalInitialState from './state/globalInitialState';
import globalReducer from './reducers/globalReducer';

import facultyInitialState from './state/facultyInitialState';
import facultyReducer from './reducers/facultyReducer';

export const StateContext = createContext();
export const DispatchContext = createContext();

export const GlobalProvider = ({children}) => {

    // const [state, dispatch name] = useReducer(reducer name, initial state);
    const [authState, authDispatch] = useImmerReducer(authReducer, authInitialState);
    const [globalState, globalDispatch] = useImmerReducer(globalReducer, globalInitialState);
    const [facultyState, facultyDispatch] = useImmerReducer(facultyReducer, facultyInitialState);

    return (
        <StateContext.Provider
            value={{
                authState,
                globalState,
                facultyState
            }}
            displayName="StateContext"
        >
            <DispatchContext.Provider
                value={{
                    authDispatch,
                    globalDispatch,
                    facultyDispatch
                }}
                displayName="DispatchContext"
            >
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
};
